import { useState } from "react";
import { ColumnAlign } from "../widgets/ColumnAlign";
import { ChoiceList } from "../widgets/ChoiceList";
import { isAccentRhotic } from "./applySets";

/** options for loading & saving accents */
export function SaveLoadBar(props: {
  /** list of accents to show, either built-in or 'Custom: ' */
  readonly allAccents: string[],
  /** called when the user types in a name for a custom rule, optionally forcing an immediate save */
  readonly onNewName: (customName: string, forceSave: boolean) => void,
  /** called when an accent is chosen from the list */
  readonly onSelectAccent: (accent: string, isCustom: boolean, rhotic: boolean) => void,
  /** called when the user wants a custom accent deleted */
  readonly onDeleteAccent: (accent: string) => void;
}) {
  const [customName, setCustomName] = useState('');
  const [selectedAccent, setSelectedAccent] = useState(props.allAccents[0]);

  function onNewName(name: string) {
    setCustomName(name);
    props.onNewName(name, false);
  }

  function onAccentKey(k: string) {
    if (k === 'Enter') {
      props.onNewName(customName, true/*forceSave*/);
    }
  }

  function onDelete() {
    props.onDeleteAccent(customName);
    setCustomName('');
    props.onNewName('', false);
  }

  function onSelectAccent(selected: string) {
    // string as it appears in list of accents
    setSelectedAccent(selected);
    // name to use if it's a custom accent
    const isCustom = selected.startsWith('Custom: ');
    const custom = isCustom ? selected.substring(8) : '';

    setCustomName(custom);
    props.onNewName(custom, false);

    const accent = isCustom ? custom : selected;
    const isRhotic = isAccentRhotic(accent, isCustom);
    props.onSelectAccent(accent, isCustom, isRhotic);
  }

  return (<ColumnAlign>{[
    <span key={1}>
      accent name&nbsp;
      <input size={18} spellCheck={false} value={customName} maxLength={50} placeholder="type name to save"
        onChange={(e) => onNewName(e.target.value)} onKeyDown={(e) => onAccentKey(e.key)} />
    </span>,
    <span key={2}>&nbsp;&nbsp;</span>,
    <button key={3} onClick={onDelete}>delete</button>,
    <span key={4}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
    <span key={5}>
      get sets from&nbsp;
      <ChoiceList items={props.allAccents} selectedItem={selectedAccent} onSelect={onSelectAccent} />
    </span>
  ]}</ColumnAlign>);
}
